/* unplugin-vue-components disabled */import script from "./Gmjt.vue?vue&type=script&lang=ts&setup=true"
export * from "./Gmjt.vue?vue&type=script&lang=ts&setup=true"

import "./Gmjt.vue?vue&type=style&index=0&id=1aa8d18b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa8d18b"]])

export default __exports__